import { render, staticRenderFns } from "./Edit.html?vue&type=template&id=6dbab2ab&"
import script from "./Edit.js?vue&type=script&lang=js&"
export * from "./Edit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports